import * as React from "react"
import "../styles.css"
import * as pageStyles from "../page_css/page.css"
import * as styles from "./page-hero.css"
import { theme } from "../theme.css"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import { colorArrayToString } from "../utils"
import { TColor } from "../types"
import Flash from "../components/flash"
import StandardCard from "../components/blocks/StandardCard"
import TicketLink  from "../components/ticket-link"
import Bumbershoot2024BlueAnim from "../graphics/Bumbershoot-2024-blue-anim.svg"
import LineupNav from "../components/lineup-nav"
import {
  Text,
  Button,
} from "../components/ui"

import {
  NavLink,
  VisuallyHidden,
} from "./ui"
import * as stylesHeader from "./header.css"
import Badge from "./badge"
import { StaticImage } from "gatsby-plugin-image"
import HeaderHero2025 from "./header-hero-2025"

interface PageHeroProps {
  title: string
  subtitle?: string
  hidePageTitle?: boolean
  image: {
    id: string
    title: string
    gatsbyImageData?: any,
    localfile?: any
  },
  overlayColor?: string | TColor
  overlayOpacity?: string,
  showPageHero?: boolean,
  showPageHeroVideo?: boolean,
  heroVideoYoutubeUrl?: string,
  heroCard?: any,
  showHeroType?: string
  ticketLinks?: string
  path?: string
  location?: string
}

//homeHero2023 - not used
const ImageHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.image && props.showPageHero && (
      <div className={styles.customHomepageImageBlock}>
        <GatsbyImage
          className={styles.pageHeroImage}
          style={{marginTop: '-100px'}}
          alt={props.image?.title ?? "Image"}
          image={getImage(props.image)}
        />
          <div className={styles.overlayContent} style={{gap:"10px"}}>
            <div style={{width: "100%", height:"auto"}}>
              <h1 className={styles.heroTitleStyle}></h1>
              <h2 className={styles.heroTitleH2Style}></h2>
              <h1 className={styles.heroTitleStyleSmall}></h1>
              <h1 className={styles.heroTitleStyleSmaller}></h1>
              <h1 className={styles.heroTitle2025Style}></h1>
              {
              /*
                <div style={{width: "200px", display: "inline-block"}}>
                  <Bumbershoot2024BlueAnim />
                </div>
              */
             }
            </div>
          
            <div className={styles.heroButtonWrapper}>
                <div className={styles.heroButton}>
                  <NavLink to="https://wl.eventim.us/wafform.aspx?afflky=ThirdStone&_act=subpromoterev3&_pky=618086&sp=8TSXH4" target="_blank">
                    <VisuallyHidden>TICKETS!</VisuallyHidden>
                      <span className={styles.heroBadge}>
                       TICKETS!
                      </span>
                  </NavLink>
                </div>
            </div>
            <div style={{width: "100vw", maxWidth:"700px"}} className={styles.heroTitle}>Limited Time Only</div>        
          </div>
      </div>
    )}
   </>
  )
}


const VideoHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.heroVideoYoutubeUrl && (
      <>
        <div className={styles.customHomepageVideoBlock}>
          <iframe 
            className={styles.customHomepageVideoIframeWrapper}  
            src={props.heroVideoYoutubeUrl} 
            title="Bumbershoot Video" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowFullScreen>
          </iframe>
        </div>
      </>
    )}
    </>
  )
}

const HeadlineHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.title && (props?.hidePageTitle !== true) && (
      <h1 className={styles.pageHeroTitle}>{props.title}</h1>
    )}
    { props.subtitle && (props?.hidePageTitle !== true) && (
      <h1 className={styles.pageHeroSubtitle}>{props.subtitle}</h1>
    )}

    </>
  )
}

// 2025 current live site - video is set via a card
// we're going to craft and entire homepage here from this card.


const CardHero:React.FC<PageHeroProps> = (props) => { 
  const { location } = props;
  
  const firstCardDataElement = props?.heroCard?.[0]?.card?.cardData?.[0] ?? null;

  if (!firstCardDataElement) {
    return null;
  }

  const { video: { video: videoObj = {} } = {}, videoThumbnail = {}, buttonText = '', title='', text='', hasButton=false } = firstCardDataElement; //video is a nested object btw.
  const { mp4Low = '', mp4Med = '' } = videoObj;
  const videoThumbnailSrc = videoThumbnail.gatsbyImageData?.images?.fallback?.src ?? "";
  const { ticketLinks } = props;

  return (
    <>
  { firstCardDataElement &&
  (
  <>

          <HeaderHero2025 />
          <div className={styles.heroContainer}
            style={{
              backgroundColor: theme.colors.black
            }}>
            <video 
              autoPlay 
              muted 
              loop 
              playsInline 
              style={{ width: '100vw', maxHeight:'50vh', position: 'static', objectFit: 'cover', height: '100%' }}
              poster={videoThumbnailSrc}
              >
              <source src={mp4Med} type="video/mp4" />
            </video>
        </div>
          <div className={styles.custom2025HeaderHeroBlackBackground} >
             <div className={styles.custom2025HeaderHeroBlackBackgroundInner}>
                <h2 className={styles.custom2025HeaderHeroBlackBackgroundText}>
                  100+ Artists. 48 Hours of Art, Sound & Spectacle.
                </h2>
                <h2 className={styles.custom2025HeaderHeroBlackBackgroundText }>
                  A vibrant collision of music, creativity, and culture
                </h2>
              <h2 className={styles.custom2025HeaderHeroBlackBackgroundText}
              style={{ paddingBottom: "20px" }} >
                  this Labor Day weekend
                </h2>
                <Button
                  variant={"sunrayButton"}
                  to={'https://wl.eventim.us/event/Bumbershoot-2025-Arts-and-Music-Festival/618086?afflky=ThirdStone&sp=8TSXH4'} target="_blank">
                  Buy Tickets
                </Button>
              </div>
          </div>
          <div className={styles.custom2025HeaderHeroRedBackground} >
            <div className={styles.custom2025HeaderHeroTicketOptions}>
              <div className={styles.ticketOptionsGroup}>
                  <h2
                    className={styles.heroTitleStyleSmall}
                    style={{ color: "#FFFFFF", fontFamily: theme.fonts.fancy, fontSize:"30px", width:"unset" }} >
                    Two Day</h2>
                  <p style={{ color: "#FFFFFF",fontFamily: theme.fonts.fancy, fontWeight:"100" }}>Admission to both days (Saturday and Sunday) of the festival. </p>
                    <Button
                      variant={"vermillionButton"}
                      to={'https://wl.eventim.us/event/Bumbershoot-2025-Arts-and-Music-Festival/618086?afflky=ThirdStone&sp=8TSXH4'}
                      target="_blank">
                      Two Day
                    </Button>
              </div>
              <div className={styles.ticketOptionsGroup}>
              <h2
                    className={styles.heroTitleStyleSmall}
                    style={{ color: "#FFFFFF", fontFamily: theme.fonts.fancy, fontSize:"30px",width:"unset" }} >Deluxe</h2>
                  <p style={{ color: "#FFFFFF", fontFamily: theme.fonts.fancy,}}>Deluxe Package (GA+) Includes:</p>
                  <ul style={{ color: "#FFFFFF", fontFamily: theme.fonts.fancy, fontWeight:"100", listStyleType: "disc", paddingLeft: "20px" }}>
                    <li>Admission both days (August 30th and 31st 2025)</li>
                    <li>Parking</li>
                    <li>Private entrance</li>
                    <li>Re-Entry</li>
                    <li>Exclusive raised viewing platforms</li>
                    <li>Private lounge, restrooms, and bars</li>
                    <li>21+ Only. No exceptions.</li>
                  </ul>
                  <Button
                      variant={"vermillionButton"}
                      to={'https://wl.eventim.us/event/Bumbershoot-2025-Arts-and-Music-Festival/618086?afflky=ThirdStone&sp=8TSXH4'}
                      target="_blank">
                      Deluxe
                    </Button>
              </div>
                <div className={styles.ticketOptionsGroup}>
                  <h2
                    className={styles.heroTitleStyleSmall}
                    style={{ color: "#FFFFFF", fontFamily: theme.fonts.fancy, fontSize:"30px",width:"unset" }} >Single Day</h2>
                    <p style={{ color: "#FFFFFF", fontFamily: theme.fonts.fancy,}}>Admission to 1 day ( Saturday or Sunday) of the festival.</p>
                  <Button
                      variant={"vermillionButton"}
                      to={'https://wl.eventim.us/event/Bumbershoot-2025-Arts-and-Music-Festival/618086?afflky=ThirdStone&sp=8TSXH4'}
                      target="_blank">
                      Single Day
                    </Button>
              </div>
            </div>
        </div>
          <div className={styles.artistRow}
            style={{ paddingBottom: '100px' }}
           >
            <h2 className={styles.custom2025HeaderHeroWhiteBackgroundText}
             style={{
              paddingTop: "50px",
              paddingBottom: "50px",
            }} >
              Music Lineup
            </h2>
            <div className={styles.artistItem}>
              <a href="/music/weezer-voyage-to-the-blue-planet/">
                <StaticImage
                  src="../graphics/artists/2025_BBS_Artist_Square_Weezer.jpg"  
                  alt="Weezer"
                  placeholder="blurred"
                style={{ width: "100%", height: "auto", display: "block" }}
                  />
              </a>
          </div>
            <div className={styles.artistItem}>
              <a href="/music/aurora/">
            <StaticImage
              src="../graphics/artists/2025_BBS_Artist_Square_Aurora.jpg"  
              alt="Aurora"                       
              placeholder="blurred"
             style={{ width: "100%", height: "auto", display: "block" }}
            /></a>
          </div>
            <div className={styles.artistItem}>
              <a href="/music/janelle-monae/">
            <StaticImage
              src="../graphics/artists/2025_BBS_Artist_Square_Janelle_Monae.jpg"  
              alt="Janelle_Monae"                     
              placeholder="blurred"
             style={{ width: "100%", height: "auto", display: "block" }}
              />
              </a>
          </div>
            <div className={styles.artistItem}>
              <a href="/music/car-seat-headrest/">
                <StaticImage
                src="../graphics/artists/2025_BBS_Artist_Square_Car_Seat_Headrest.jpg"  
                alt="Car_Seat_Headrest"                      
                placeholder="blurred"
                style={{ width: "100%", height: "auto", display: "block" }}
              /></a>
            </div>
            <div style={{width: "100%", height:"auto", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <Button
                  variant={"rubyButton"}
                  to={'/music-lineup'}>
                  SEE MORE
              </Button>
              </div>
            </div>
          <div className={styles.custom2025HeaderHeroRedBackgroundArts} >
            <h2 className={styles.custom2025HeaderHeroWhiteBackgroundTextArts}>Arts Lineup</h2>
            <div className={styles.artRow}>
              <div className={styles.artItem}>
                <a href="/artists/fashion-district/"
                style={{ textDecoration: "none" }}>
                  <StaticImage
                      src="../graphics/artists/fashiondistrict.png"  
                      alt="Fashion Distrct"                    
                      placeholder="blurred"
                      className={styles.artWrapper}
                      imgClassName={styles.artImage}
                  />
                <h2 className={styles.artItemText}>Fashion District</h2>
                </a>
              </div>
              <div className={styles.artItem}>
                <a href="/artists/recess-district/"
                style={{ textDecoration: "none" }}>
                <StaticImage
                    src="../graphics/artists/bumbermania.png"  
                    alt="Recess District"                    
                    placeholder="blurred"
                    className={styles.artWrapper}
                    imgClassName={styles.artImage}
                  />
                  <h2 className={styles.artItemText}>Recess District</h2>
                  </a>
              </div>
              <div className={styles.artItem}>
                <a href="/artists/dome-district/"
                style={{ textDecoration: "none" }}>
                <StaticImage
                    src="../graphics/artists/dome-district.png"  
                    alt="Sculpture Program"                    
                    placeholder="blurred"
                    className={styles.artWrapper}
                    imgClassName={styles.artImage}
                />
                  <h2 className={styles.artItemText}>Geodesic Dome Program</h2>
                  </a>
              </div>
            </div>
            <div style={{width: "100%", height:"auto", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <Button
                  variant={"vermillionButton"}
                  to={'/artist-lineup'}>
                  SEE MORE
              </Button>
              </div>
          </div>
          <div className={styles.custom2025HeaderHeroBackgroundCulinary} >
            <h2 className={styles.custom2025HeaderHeroWhiteBackgroundTextArts}>Culinary Lineup</h2>
            <div className={styles.culinaryRow}>
              <div className={styles.culinaryItem}>
                <a href="/culinary-lineup#eat"
                style={{ textDecoration: "none" }}>
                  <StaticImage
                      src="../graphics/culinary/EvasWildSquare.jpg"  
                      alt="EAT"                    
                      placeholder="blurred"
                      className={styles.artWrapper}
                      imgClassName={styles.artImage}
                  />
                <h2 className={styles.artItemText}>EAT</h2>
                </a>
              </div>
            <div className={styles.culinaryItem}>
                <a href="/culinary-lineup#vineshoot"
                style={{ textDecoration: "none" }}>
                  <StaticImage
                      src="../graphics/culinary/AdditionSquare.jpg"  
                      alt="VineShoot"                    
                      placeholder="blurred"
                      className={styles.artWrapper}
                      imgClassName={styles.artImage}
                  />
                <h2 className={styles.artItemText}>VineShoot</h2>
                </a>
              </div>
              <div className={styles.culinaryItem}>
                <a href="/culinary-lineup#cocktail-corner"
                style={{ textDecoration: "none" }}>
                <StaticImage
                    src="../graphics/culinary/RobRoySquare.jpg"  
                    alt="Cocktail Corner<"                    
                    placeholder="blurred"
                    className={styles.artWrapper}
                    imgClassName={styles.artImage}
                  />
                  <h2 className={styles.artItemText}>Cocktail Corner</h2>
                  </a>
              </div>
              <div className={styles.culinaryItem}>
                <a href="/culinary-lineup#bumbeershoot"
                style={{ textDecoration: "none" }}>
                <StaticImage
                    src="../graphics/culinary/BizzareSquare.jpg"  
                    alt="Sculpture Program"                    
                    placeholder="blurred"
                    className={styles.artWrapper}
                    imgClassName={styles.artImage}
                />
                  <h2 className={styles.artItemText}>bumBEERshoot</h2>
                  </a>
              </div>
            </div>
            <div style={{width: "100%", height:"auto", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <Button
                  variant={"vermillionButton"}
                  to={'/artist-lineup'}>
                  SEE MORE
              </Button>
              </div>
          </div>
            {/*
          <div className={styles.overlayContent} style={{gap:"10px"}}>
            <div style={{width: "100%", height:"auto"}}>
              <h1 className={styles.heroTitleStyle}>GA Weekend Passes $225* +Fees</h1>
              <h2 className={styles.heroTitleH2Style}>for</h2>
              <h1 className={styles.heroTitleStyleSmall}>Bumbershoot</h1>
              <h1 className={styles.heroTitleStyleSmaller}>Arts &amp; Music Festival</h1>
              <h1 className={styles.heroTitle2025Style}>2025</h1>
          
            </div>
         
            <div className={styles.heroButtonWrapper}>
                <div className={styles.heroButton}>
                  <NavLink to="https://wl.eventim.us/wafform.aspx?afflky=ThirdStone&_act=subpromoterev3&_pky=618086&sp=8TSXH4" target="_blank">
                    <VisuallyHidden>TICKETS!</VisuallyHidden>
                      <span className={styles.heroBadge}>
                       TICKETS!
                      </span>
                  </NavLink>
                </div>
            </div>
            <div style={{width: "100vw", maxWidth:"700px"}} className={styles.heroTitle}>*Limited Time Only</div>        
            </div>
            */
            }
    </>
  )}
  </>
  )
}

const PageHero: React.FC<PageHeroProps> = (props) => {
  const ticketLinks = TicketLink();
  const { showHeroType } = props;

  switch (showHeroType) { 
   // case "no_hero":
   //   return null;
    case "image_hero":
      return (<ImageHero {...props} />);
    case "video_hero":
      return (<VideoHero {...props} />);
    case "card_hero":
      return (<CardHero {...props} ticketLinks={ticketLinks}/>);
    case "headline_hero":
      return (<HeadlineHero {...props} />);
    default:
      return (<HeadlineHero {...props} />);
  }

}

export default PageHero
